import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';

export default class QuestionnaireAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare state: StateService;

  get canRead(): boolean {
    if (!this.state.features?.canAccessQuestionnaires) return false;

    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_QUESTIONNAIRE_READ);
  }

  get canReadGlobal(): boolean {
    if (!this.state.features?.canAccessQuestionnaires) return false;

    return this.authz.hasPermissionAtCurrentCompany(Permission.VISITORS_QUESTIONNAIRE_READ);
  }

  get canCreate(): boolean {
    if (!this.state.features?.canAccessQuestionnaires) return false;

    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_QUESTIONNAIRE_CREATE);
  }

  get canCreateGlobal(): boolean {
    if (!this.state.features?.canAccessQuestionnaires) return false;

    return this.authz.hasPermissionAtCurrentCompany(Permission.VISITORS_QUESTIONNAIRE_CREATE);
  }

  get canUpdate(): boolean {
    if (!this.state.features?.canAccessQuestionnaires) return false;

    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_QUESTIONNAIRE_UPDATE);
  }

  get canUpdateGlobal(): boolean {
    if (!this.state.features?.canAccessQuestionnaires) return false;

    return this.authz.hasPermissionAtCurrentCompany(Permission.VISITORS_QUESTIONNAIRE_UPDATE);
  }

  get canDelete(): boolean {
    if (!this.state.features?.canAccessQuestionnaires) return false;

    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_QUESTIONNAIRE_DELETE);
  }

  get canDeleteGlobal(): boolean {
    if (!this.state.features?.canAccessQuestionnaires) return false;

    return this.authz.hasPermissionAtCurrentCompany(Permission.VISITORS_QUESTIONNAIRE_DELETE);
  }

  get canNavigate(): boolean {
    if (!this.state.features?.canAccessQuestionnaires) return false;

    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_QUESTIONNAIRE_NAV);
  }

  get canNavigateToGlobal(): boolean {
    if (!this.state.features?.canAccessQuestionnaires) return false;

    return this.authz.hasPermissionAtCurrentCompany(Permission.VISITORS_QUESTIONNAIRE_NAV);
  }
}
